import { render, staticRenderFns } from "./choose_list.vue?vue&type=template&id=4845daca&scoped=true"
import script from "./choose_list.vue?vue&type=script&lang=js"
export * from "./choose_list.vue?vue&type=script&lang=js"
import style0 from "./choose_list.vue?vue&type=style&index=0&id=4845daca&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4845daca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4845daca')) {
      api.createRecord('4845daca', component.options)
    } else {
      api.reload('4845daca', component.options)
    }
    module.hot.accept("./choose_list.vue?vue&type=template&id=4845daca&scoped=true", function () {
      api.rerender('4845daca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/transferDiscountPoolAndRedPool/setting/form/choose_list.vue"
export default component.exports